<template>
  <v-container fluid>

    <v-col cols="12">

      <v-row align="center" justify="space-between">
        <v-col cols="12" md="4">
          <h1 class="mb-0"
              :class="$vuetify.theme.isDark ? 'white--text' : ''" >
            Rutas
          </h1>
        </v-col>

        <v-col cols="8" md="7">
          <v-text-field hide-details dense outlined flat v-model="search" append-icon="mdi-magnify"
                        label="Buscar...">
          </v-text-field>
        </v-col>

        <v-col cols="4" md="1">
          <v-row justify="center">
            <v-btn fab small elevation="0" color="primary" @click="createItem()">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-col>


    <v-card>
      <v-card-text>
        <v-row class="elevated-3">
          <v-col>
            <v-col xs="12" md="12" sm="12">

              <v-data-table :headers="headers" :items="sortedItems" :search="search">

                <template v-slot:item.enabled="{item}">
                  <v-icon v-if="item.enabled" large color="success" >mdi-check-circle-outline</v-icon>
                  <v-icon v-else large color="grey" >mdi-close-circle-outline</v-icon>
                </template>

                <template v-slot:item.actions="{item}">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn class="mx-1" fab x-small color="warning" dark depressed
                             @click="editItem(item)" v-on="on">
                        <v-icon >mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                </template>

              </v-data-table>

            </v-col>
          </v-col>
        </v-row>
      </v-card-text>

    </v-card>
    <v-dialog max-width="400"  v-model="modal.visible">
    <v-card>
      <v-form class="pa-0" ref="form" v-model="validForm" lazy-validation>
      <v-card-title v-if="!modal.payload.id">Crear Ruta</v-card-title>
        <v-card-title v-if="modal.payload.id">Editar Ruta</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12">
            <v-text-field :rules="emptyRule" v-model="modal.payload.name" hide-details dense outlined label="Nombre"></v-text-field>
          </v-col>
          <v-col>
          <v-switch v-model="modal.payload.enabled" label="Activo"></v-switch>
          </v-col>

        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn :disabled="!validForm" color="primary" @click="validateForm">Guardar</v-btn>
        <v-col align="right"> <v-btn color="secondary" @click="modal.visible=false">Cancelar</v-btn></v-col>
      </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>

  </v-container>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      search: '',
      headers: [{
        text: 'ID',
        align: 'center',
        value: 'id',
      },
        {
          text: 'Nombre',
          align: 'center',
          value: 'name',
        },

        {
          text: 'Activo',
          align: 'center',
          value: 'enabled'
        },

        {
          text: 'Acciones',
          align: 'center',
          value: 'actions'
        }
      ],
      modal: {
        visible:false,
        payload: {
          name: null,
          enabled:1
        },
      },
      validForm: true,
      emptyRule: [v => !!v || 'Necesario'],
    };
  },
  computed: {
    sortedItems(){
      return this.items.sort((a, b) => (a.id < b.id) ? 1 : -1)
    }
  },
  methods: {
    validateForm() {
      if (this.$refs.form.validate()) {
        (this.modal.payload.id ? this.update() : this.store())
      }
    },
    createItem() {
      this.modal.payload={enabled:1};
      // this.modal.payload.name=''
      // this.modal.payload.enabled=1
      this.modal.visible=true
    },
    store()
    {

      this.$axios
          .post('/admin/deliveryroutes', this.modal.payload)
          .then((response) => {
            // console.log(response.data)
            this.$store.commit('OPEN_SNACKBAR', response.data);
            (response.data.success ? this.modal.visible=false : '')
            this.getDataFromAPI()
          })
          .catch((error)=>{

          });
    },

    editItem(item) {
      this.modal.payload=item
      this.modal.visible=true
    },

    update() {
      let formData = new FormData();

      // Loops the payload and inserts it inside formData
      Object.entries(this.modal.payload).forEach(([key, value]) => {
        formData.append(key, value)
      })

      // Laravel put workaround
      formData.append('_method', 'PUT')

      this.$axios
          .post(`/admin/deliveryroutes/${this.modal.payload.id}`, formData)
          .then((response) => {
            // console.log(response.data)
            this.$store.commit('OPEN_SNACKBAR', response.data);
            (response.data.success ? this.modal.visible=false : '')
            this.getDataFromAPI()
          })
          .catch((error)=>{
            console.log(error);
          });
    },


    getDataFromAPI() {
      this.$axios
          .get('/admin/deliveryroutes')
          .then((response) => {
            this.items = response.data

          })
    }
  },
  mounted() {
    this.getDataFromAPI()
  }
}
</script>